import { CommercialIndustries, Division } from "../../features/api-interfaces";
import { DivisionDict } from "../default-constants";

// 料率調整案件一覧のラベル
export const LABELS = {
  TITLE: "料率調整案件一覧",
  BTN_REGISTER: "　新規登録　",

  CORPORATE_NUMBER: "法人番号",
  CONTRACT_PRESENCE_ABSENCE: "契約有無",
  COMPANY_NAME: "事業者名",
  MERCHANT_NAME: "加盟店名",
  SERVICE_NAME: "サービス名",
  INDUSTRY: "業態",
  MERCHANDISE: "取扱商材",
  RESPONSE_DATE: "回答日",
  SALES: "売上高",
  LIST_SALES: "売上高（億円）",
  CONTRACT_ROUTE: "契約ルート",
  APPLICATION_DATE: "申請日",
  ALL_SHOP_NUMBER: "総店舗数",
  INSTALLED_SHOP_NUMBER: "導入店舗数",
  DESIRED_RATE: "希望料率",
  COST_BURDEN: "費用負担",
  COST_BURDEN_ADJUSTMENT_INFO: "費用負担情報",
  NOTE: "備考",
  DIRECT: "直接",
  INCLUSION: "包括",
  BILLION_YEN: "百万円",
  EMPTY: "　",
  FROM: "～",
  SERVICE_NAME_BARCODE: "d払い（バーコード）",
  UN_SELECT: "未選択",

  DOCOMO_INDUSTRY: "ドコモ定義業態",
  APPLICATION_INDUSTRY: "申請業態",

  RATE_PRESENTATION_CONDITION: "料率提示条件",
  RESPONSE_RATE: "回答料率",

  RATE_ADJUSTMENT_MEMBER_STORE: "料率調整加盟店",
  COORDINATION_REQUESTER: "調整依頼元",

  DOWNLOAD_BTN: "ダウンロード",
};
// SELECTの空行の定義
export const SELECT_BLANK = { label: "　　　　　　", value: "" };

// 料率調整案件一覧ビューではコード値ではなく名称を保持しているため
// valueにも名称を格納する

// 変換後業態コード取得結果変換
export const getIndustryConversionsItems = (
  industries: CommercialIndustries[] | undefined
): DivisionDict[] => {
  if (industries !== undefined) {
    return industries.map((industries) => ({
      label: industries.industryName,
      value: industries.industryName,
    }));
  }
  return [];
};

// 区分取得結果変換
export const getDivisionItems = (
  divisions: Division[] | undefined
): DivisionDict[] => {
  if (divisions !== undefined) {
    return divisions.map((division) => ({
      label: division.label,
      value: division.label,
    }));
  }
  return [];
};
